import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { useHasRouteAccess } from '@client/hooks/navigation/useHasRouteAccess';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Trash2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/trash')({
    staticData: {
        metadata: { title: 'Trash' },
        ui: {
            icon: Trash2,
            title: 'Trash',
            subtitle: 'Review, restore or permanently delete items removed from your organisation',
            menuDescription: 'Restore or permanently delete removed items',
            useTitleForChildren: true,
        },
        permissions: ['org:admin'],
    },
    component: OrgTrashLayout,
});

function OrgTrashLayout() {
    // CUR-1232: deleted registers get their own tab. An org without registers
    // has only one kind of item in Trash, so no tab bar — the Files page renders
    // as it always has.
    const hasRouteAccess = useHasRouteAccess();
    const showRegisters = hasRouteAccess('/console/$orgId/configuration/org-settings/trash/registers');

    return (
        <PageController route={Route}>
            {showRegisters ? (
                <Tabs
                    items={[
                        { label: 'Files', to: '/console/$orgId/configuration/org-settings/trash/files' },
                        { label: 'Registers', to: '/console/$orgId/configuration/org-settings/trash/registers' },
                    ]}
                />
            ) : (
                <Outlet />
            )}
        </PageController>
    );
}
